"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/Controls/BatchControls.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);








var _broadcast = require('shared/selectors/broadcast');
var _format = require('web/screens/Broadcast/format');
var _campaignState = require('web/screens/Broadcast/campaignState');
var _useCampaignSchedule = require('web/screens/Broadcast/useCampaignSchedule'); var _useCampaignSchedule2 = _interopRequireDefault(_useCampaignSchedule);
var _addingRecipients = require('web/screens/Broadcast/addingRecipients');
var _hooks = require('web/services/hooks');

var _Form = require('web/components/Form');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _DisabledReason = require('web/screens/Broadcast/DisabledReason'); var _DisabledReason2 = _interopRequireDefault(_DisabledReason);
var _ScheduledControl = require('./ScheduledControl'); var _ScheduledControl2 = _interopRequireDefault(_ScheduledControl);







/* Rev 33 T2: one Pause. It stops sending and returns everything not yet sent
 * to Not scheduled (asking first); a paused campaign's Send… reads Resume…,
 * opening the same Send dialog. */
const BatchControls = ({ campaignKey, onPauseCampaign, onQueueMessages }) => {
  const isActive = _hooks.useAppSelector.call(void 0, state => _broadcast.selectIsCampaignActive.call(void 0, state, campaignKey))
  const isArchived = _hooks.useAppSelector.call(void 0, state => _broadcast.selectIsCampaignArchived.call(void 0, state, campaignKey))
  const queuedCount = _hooks.useAppSelector.call(void 0, state => _broadcast.selectCampaignQueuedCount.call(void 0, state, campaignKey))
  const isPaused = _hooks.useAppSelector.call(void 0, state => {
    const campaign = _broadcast.selectCampaignByKey.call(void 0, state, campaignKey)
    return !!campaign && _campaignState.isPausedCampaign.call(void 0, campaign)
  })
  const isQueuedOnly = _hooks.useAppSelector.call(void 0, state => {
    const campaign = _broadcast.selectCampaignByKey.call(void 0, state, campaignKey)
    return !!campaign && _campaignState.isResumeQueuedOnly.call(void 0, campaign)
  })
  const notScheduledCount = _hooks.useAppSelector.call(void 0, state => _broadcast.selectCampaignNotScheduledCount.call(void 0, state, campaignKey))
  const schedule = _useCampaignSchedule2.default.call(void 0, campaignKey)
  // P2': Send now, Schedule and Resume wait for a background Add to finish.
  const isAddingRecipients = _addingRecipients.useIsAddingRecipients.call(void 0, campaignKey)
  const [isConfirmingPause, setIsConfirmingPause] = _react.useState.call(void 0, false)
  // Rev 35 E3: while a batch runs, everyone not in it (left out of the batch,
  // or added since) waits Not scheduled; the batch stops on its own when
  // done, and the next Resume… includes them. Not while a schedule is being
  // sent: the controls read Scheduled then.
  const waitingCount = isActive && !schedule.isPending ? notScheduledCount : 0

  const renderRunControl = () => {
    if (schedule.state === 'scheduled' && schedule.startAt) {
      return (
        _react2.default.createElement(_ScheduledControl2.default, {
          isPending: schedule.isPending,
          onPause: () => setIsConfirmingPause(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
        )
      )
    }
    if (!isActive && isQueuedOnly) {
      // Nothing to queue: Resume sends the messages still queued, no dialog.
      return (
        _react2.default.createElement(_Form.Button, {
          isDisabled: isArchived,
          onClick: onQueueMessages,
          className: "campaign-controls--batch--toggle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}

          , _react2.default.createElement('i', { className: "campaign-controls--batch--toggle-icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}} ), "Resume"

        )
      )
    }
    if (!isActive) {
      // One plain button; the dialog sends now unless a time is set there.
      return (
        _react2.default.createElement(_DisabledReason2.default, { reason: isAddingRecipients && !isArchived ? _addingRecipients.WAIT_FOR_ADD_REASON : null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
          , _react2.default.createElement(_Form.Button, {
            onClick: onQueueMessages,
            isDisabled: isArchived || !notScheduledCount || isAddingRecipients,
            className: "campaign-controls--batch--toggle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}

            , _react2.default.createElement('i', { className: "campaign-controls--batch--toggle-icon", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}} )
            ,  isPaused ? 'Resume…' : 'Send…' 
          )
        )
      )
    }
    return (
      _react2.default.createElement('div', { className: "campaign-controls--batch--toggle--wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
        , _react2.default.createElement(_Form.Button, { isDisabled: true, className: "campaign-controls--batch--toggle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
          , _react2.default.createElement('i', { className: "campaign-controls--batch--toggle-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}} ), "Running"

        )
        , _react2.default.createElement('button', {
          type: "button",
          'aria-label': "Pause",
          title: "Pause",
          onClick: () => setIsConfirmingPause(true),
          className: "campaign-controls--batch--toggle--pause-btn", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}
        )
      )
    )
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  renderRunControl() 
      ,  waitingCount > 0 && schedule.state !== 'scheduled' && (
        _react2.default.createElement('span', { className: "campaign-controls--batch--waiting", __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}
          ,  _format.formatCount.call(void 0, waitingCount) , " more waiting · sent on Resume"
        )
      )
      , _react2.default.createElement(_Modal2.default, {
        isOpen: isConfirmingPause,
        title: "Pause the campaign?"  ,
        size: "xs",
        onClose: () => setIsConfirmingPause(false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 116}}

        , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}, "Sending stops. The "
             ,  _format.formatCount.call(void 0, queuedCount) , " messages not sent yet go back to Not scheduled; Resume sends them. Messages already sent aren't affected."

        )
        , _react2.default.createElement(_Modal.ModalControls, {
          secondaryBtnLabel: "Keep sending" ,
          onSecondaryBtnClick: () => setIsConfirmingPause(false),
          primaryBtnLabel: "Pause",
          onPrimaryBtnClick: () => {
            setIsConfirmingPause(false)
            onPauseCampaign()
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, BatchControls)
